import {Component, Input, OnInit} from '@angular/core';
import {CityService} from '@services/city.service';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-square-rent',
    templateUrl: './square-rent.component.html',
    styleUrls: ['./square-rent.component.scss']
})
export class SquareRentComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor(public cityService: CityService) {
    }

    ngOnInit() {
    }
}

